import { useSyncExternalStore } from "react";
import { BACKEND } from "@/lib/host";

// Connectivity = real reachability of the API (navigator.onLine alone is not trusted).
const PING = `${BACKEND}/api/`;
const subs = new Set();
let online = typeof navigator === "undefined" ? true : navigator.onLine;
let timer = null;

function set(v) {
  if (v === online) return;
  online = v;
  subs.forEach((f) => f(v));
  schedule();
}

export async function probe() {
  if (!navigator.onLine) {
    set(false);
    return false;
  }
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), 4000);
  try {
    const r = await fetch(`${PING}?_=${Date.now()}`, { cache: "no-store", signal: ctl.signal });
    set(r.status < 500);
  } catch {
    set(false);
  } finally {
    clearTimeout(t);
  }
  return online;
}

function schedule() {
  clearTimeout(timer);
  timer = setTimeout(async () => {
    await probe();
    schedule();
  }, online ? 20000 : 5000);
}

export const isOnline = () => online;
export const markOnline = () => set(true);
export const onConnectivity = (f) => {
  subs.add(f);
  return () => subs.delete(f);
};
export const useOnline = () => useSyncExternalStore(onConnectivity, isOnline);

if (typeof window !== "undefined") {
  window.addEventListener("offline", () => set(false));
  window.addEventListener("online", () => probe());
  schedule();
}
